export const sxStyles = {
  root: {
    backgroundColor: '#eee',
    display: 'flex',
    alignItems: 'center',
  },
};
